import { useEffect, useState } from 'react';
import Desktop from './Desktop.tsx';
import Mobile from './Mobile.tsx';

function Header() {
  const [isMobile, setIsMobile] = useState(false);
  
  useEffect(() => {
    const updateSize = () => {
      setIsMobile(window.innerWidth <= 1290);
    }
  
    updateSize();
  
    window.addEventListener('resize', updateSize);
    return () => window.removeEventListener('resize', updateSize);
  }, [])
  
    return (
      <>
        {isMobile ? <Mobile /> : <Desktop />}
      </>
    )
  }

export default Header;